//TODO to optimize and refactor
import { useEffect, useState } from "react";
import {
  useGetDevice,
  useGetServer,
  useLoggedInUser,
  usePlantsListById
} from "../../../api/userInfo";

import { useNavigate } from "react-router-dom";
import { useGetCompanyPlants } from "src/api/dashboard";
import DeviceDetails from "src/components/device_management/deviceDetails";
import ServerDetails from "src/components/device_management/serverDetails";
import { useSWRConfig } from "swr";
import Header from "../../../components/layout/Header";
import SelectSiteHeader from "../../../components/layout/SelectSiteHeader";
import SiteCard from "../../../components/site_management/site-card";
import LoadingContainer from "src/components/ui/loading/loading-container";
import { useDempStore } from "src/context/stores";
import { useTranslation } from 'react-i18next'

const DeviceManagement = () => {
  const [dashboardId, plantId, companyId, updatePlantId] = useDempStore((state) => [
    state.dashboardId,
    state.plantId,
    state.companyId,
    state.updatePlantId,
  ]);
  
  const { plantsListById } = usePlantsListById(plantId);
  const { plants: listOfPlants, isErrorPlants, isLoadingPlants } = useGetCompanyPlants(companyId);
  const { deviceList, isErrorDeviceList, isLoadingDeviceList } = useGetDevice(plantId);
  const { serverList, isErrorServerList, isLoadingServerList } = useGetServer(plantId);
  const [deviceListState, setDeviceListState] = useState(deviceList);
  const { t } = useTranslation("settings");
  const showData = plantsListById?.role?.toLowerCase() != "user";

  const updateSelectedPlant = (plant_id) => {
    updatePlantId(plant_id);
    // localStorage.setItem("plantId", plant_id);
    // window.location.reload(false);
  };

  useEffect(() => {
    setDeviceListState(deviceList);
  }, [deviceList]);

  return (
    <>
      <Header pageTitle="Devices" showSubMenu={false}>
        <SelectSiteHeader />
      </Header>

      <div className="h-full overflow-x-auto overflow-y-hidden layout rounded-xl ">
        <LoadingContainer
          isLoading={isLoadingPlants}
          isError={isErrorPlants}
          hasData={listOfPlants?.length > 0}
          loadingText={`${t('device_management.loading.loading_plant')}...`}
          errorText={`${t('device_management.loading.error_plant')}`}
          noDataText={`${t('device_management.loading.no_plant')}`}
        >
        <div className="p-4 mx-4 mt-4 mb-4 overflow-x-auto bg-white rounded-md shadow">
          <div className="flex py-2 pl-4 top-28">
            {listOfPlants?.map((item, index) => {
              return (
                <div className={"relative"} key={item?.name}>
                  {plantId == item?.id && (
                    <span className="absolute z-[20] -top-2 right-1">
                      <i className="text-lg text-white rounded-full bg-vekin ri-check-line"></i>
                    </span>
                  )}
                  <SiteCard
                    key={item.name}
                    detailSite={{
                      Id: item.id,
                      Name: item.name,
                      Image: item.main_image_file,
                      Active: true,
                      Visible: true,
                    }}
                    onClick={(e) => {
                      updateSelectedPlant(item.id);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
        </LoadingContainer>

        {showData && (
          <ServerDetails
            deviceList={deviceListState}
            isLoadingServerList={isLoadingServerList}
            isErrorServerList={isErrorServerList}
            serverList={serverList?.server}
            plantId={plantId}
          />
        )}
        <DeviceDetails
          deviceList={deviceListState}
          isLoadingDeviceList={isLoadingDeviceList}
          isErrorDeviceList={isErrorDeviceList}
          showData={showData}
          plantId={plantId}
        />
      </div>
    </>
  );
};

export default DeviceManagement;
